import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faDownload, faAddressCard } from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import { ThemeContext } from '../Common/ThemeProvider';
import QRCode from 'qrcode.react';
import * as htmlToImage from 'html-to-image';
import IDCardTheme from '../../Images/IDCardTheme.png';
import moment from 'moment';
import { FetchUsersByID, FetchUsers } from '../Common/Services/UserService';
import { CallBackAlert } from '../Common/Validations/validation';
import BusinessDetails from './BusinessDetails';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';
import UserList from './ReusableComponents/UserList';
import Avatar from '../../Images/Avatar.png';
import WaterMark from '../../Images/Watermark_IDCard.png';
import mfi_IDCard_logo from '../../Images/mfi_IDCard_logo.png';

const MerchantCode = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [usersData, setusersData] = useState([]);
    const [FilterUsers, setFilterUsers] = useState([]);
    const [SelectedUsers, setSelectedUsers] = useState({});
    //const [ProfilePhoto, setProfilePhoto] = useState(null);
    const [IsBusinessSelected, setIsBusinessSelected] = useState(false);

    useEffect(() => {
        FetchUsersData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onUsersSearch = (searchValue) => {
        if (searchValue !== "") {
            let userSearchData = usersData.filter(c => c.FirstName.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.LastName.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                (c.Organization.length > 0 && c.Organization[0].Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase())));
            setFilterUsers(userSearchData);
        }
        else {
            setFilterUsers(usersData);
        }
    };

    const FetchUsersData = () => {
        const userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData !== null && userData.Role.length > 0 && userData.Role[0].Name.toUpperCase() !== "ADMIN") {
            FetchUsersByID({ _id: userData._id }, UserSuccess, Failure);
        }
        else {
            FetchUsers(null, UserSuccess, Failure);
        }
    };

    const UserSuccess = (data) => {
        setusersData(data);
        setFilterUsers(data);
        if (!IsUndefinedNullOrEmpty(SelectedUsers._id)) {
            let userdata = data.filter(u => u._id === SelectedUsers._id);
            if (userdata.length > 0) {

                setSelectedUsers(userdata[0]);
            }
        }
    };

    const GenerateQRCode = (userData) => {
        //setProfilePhoto(null);
        if (userData && userData._id !== "") {
            setSelectedUsers(userData);
            // if (userData.Photo !== undefined && userData.Photo !== null) {
            //     Axiosfetch(baseURL + "GetUserPhoto", "POST", { fileName: userData.Photo }, UserImageSuccess, Failure);
            // }
        }
        else {
            setSelectedUsers("");
        }
    };

    // const UserImageSuccess = (data) => {
    //     setProfilePhoto(data);
    // };

    const DownloadImage = () => {
        var node = document.getElementById('IDCard');
        var validTill = document.getElementsByClassName('validTill');
        if (validTill.length > 0) {
            validTill[0].style = "display:none;";
        }

        htmlToImage.toPng(node)
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = SelectedUsers.UserName + '_IDCard.png';
                link.href = dataUrl;
                link.click();

                if (validTill.length > 0) {
                    validTill[0].style = "display:block";
                }
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
    };

    const onWebSiteClick = (website) => {
        if (website !== "") {
            window.open((website.indexOf("http") === -1 ? "http://" : "") + website);
        }
    };

    const onBusinessDetailsClick = () => {
        setIsBusinessSelected(true);
    };

    const hidebusinessDetails = () => {
        setIsBusinessSelected(false);
    };

    const SaveBusinessDetails = (details) => {
        if (SelectedUsers && !IsUndefinedNullOrEmpty(SelectedUsers.Organization) &&
            SelectedUsers.Organization.length > 0) {
            Axiosfetch(baseURL + "UpdateAboutInfo", "POST", {
                _id: SelectedUsers.Organization[0]._id,
                AboutInfo: details
            }, AboutInfoSuccess, Failure);
        }
    };

    const AboutInfoSuccess = (data) => {
        setIsBusinessSelected(false);

        if (data.success) {
            FetchUsersData();
        }

        CallBackAlert(data);
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>ID card</h5>
                    </div>
                </div>
                <div className="col-md-12" style={{ height: "75vh" }}>
                    <div className="row" style={{ marginLeft: "5px", marginRight: "5px", height: "70vh" }}>
                        <div className="col-md-5" style={{
                            borderRight: "1px solid #ccc",
                            borderTop: "1px solid #ccc"
                        }}>

                            <div style={{ marginBottom: "20px", position: "relative" }}>
                                <input type="text" name="Name" placeholder="Search User..."
                                    className="input-control" style={{ outline: "none", marginRight: "10px", borderRadius: "20px", paddingLeft: "40px", borderTop: "none", borderTopLeftRadius: "0", borderTopRightRadius: "0" }}
                                    onChange={e => onUsersSearch(e.target.value)}></input>
                                <div className={`${CurrentTheme}Color`} style={{ fontSize: "1.1rem", position: "absolute", left: "89%", top: "13%" }}>
                                    <FontAwesomeIcon icon={faSearch} />
                                </div>
                            </div>
                            <div style={{ height: "65vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                                <UserList FilterUsers={FilterUsers} GenerateQRCode={GenerateQRCode} SelectedUsers={SelectedUsers}></UserList>
                            </div>
                        </div>
                        <div className="col-md-7" style={{
                            borderL: "1px solid #ccc",
                            borderTop: "1px solid #ccc", paddingTop: "10px"
                        }}>
                            <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                                <div className="col-md-12 col-sm-12 col-sm-12 mb-4">

                                    {SelectedUsers._id !== undefined &&
                                        SelectedUsers._id.toString() !== "" && (<div style={{ display: "flex", justifyContent: "space-around" }}>
                                            <div title="Download" className={`${CurrentTheme}Color`} style={{ cursor: "pointer", fontSize: "25px", height: "50px" }}
                                                onClick={DownloadImage}>
                                                <FontAwesomeIcon icon={faDownload} />
                                            </div>

                                            <div id="IDCard">
                                                <div className="row">
                                                    <div className="mb-1 pt-2 card card-small" style={{ backgroundPosition: "top", backgroundImage: ('url(' + IDCardTheme + ')') }}>
                                                        {SelectedUsers.ExpiryDate && (<div className="validTill mb-1" style={{ padding: "0", borderBottom: "1px solid #ccc", borderRadius: "0" }}>
                                                            <span className="validTillText">Valid Till : {moment(SelectedUsers.ExpiryDate).local().format("MMM YYYY")}</span>
                                                        </div>)}
                                                        <div className="border-bottom text-center" style={{ position: "relative" }}>
                                                            <img style={{ position: "absolute", left: "10px", top: "5px" }}
                                                                className="rounded-circle" width="45" height="35" alt="Logo" src={mfi_IDCard_logo}></img>
                                                            {SelectedUsers.Photo !== "" && SelectedUsers.Photo !== null && SelectedUsers.Photo !== undefined ? (<div className="mx-auto">
                                                                {/* <img className="rounded-circle" src={ProfilePhoto} alt="profile"
                                                                    width="100" height="100"></img> */}
                                                                <img className="rounded-circle" width="100" height="100" alt="Logo" src={`${baseURL}UserLogo/${SelectedUsers.Photo}`}></img>
                                                            </div>) : (<div className="mx-auto">
                                                                <img className="rounded-circle" src={Avatar} alt="profile"
                                                                    width="100" height="100"></img>
                                                            </div>)}
                                                            <h3 style={{ color: "#005582" }} className="mb-1">
                                                                <span style={{ background: "rgba(255,255,255,0.8)" }}>
                                                                    {SelectedUsers.FirstName + " " + SelectedUsers.LastName}
                                                                </span>
                                                            </h3>
                                                            {SelectedUsers && SelectedUsers._id && SelectedUsers._id !== "" &&
                                                                (<div style={{ position: "absolute", top: "2%", right: "3%" }}>
                                                                    <QRCode renderAs="svg" bgColor={'white'} size={50}
                                                                        includeMargin={false} level="M"
                                                                        value={SelectedUsers._id.toString()} />
                                                                </div>)}
                                                        </div>
                                                        <ul className="list-group list-group-flush">
                                                            <li className="px-4 pt-1 pb-1 list-group-item">
                                                                <div className="progress-wrapper" style={{ width: "280px" }}>
                                                                    <div className='text-center p-1' style={{ textTransform: 'uppercase' }}>
                                                                        <strong className='cursorpointer' onClick={() => onWebSiteClick(((SelectedUsers.Organization && SelectedUsers.Organization.length > 0) ? SelectedUsers.Organization[0].Website : ""))}>
                                                                            {SelectedUsers._id}</strong>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li style={{ backgroundPosition: "top", backgroundRepeat: "no-repeat", backgroundSize: "contain", backgroundImage: "url('" + WaterMark + "')" }} className="ps-3 pb-1 pt-1 list-group-item text-center">
                                                                <strong className="text-muted d-block">Member Name</strong>
                                                                <h6 style={{ background: "rgba(255,255,255,0.6)" }}>{SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && `MFI ${SelectedUsers.Organization[0].City}`}</h6>
                                                                <strong className="text-muted d-block">Organization</strong>
                                                                <h6 style={{ background: "rgba(255,255,255,0.6)", width: "100%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
                                                                    {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && SelectedUsers.Organization[0].Name}</h6>
                                                                <strong className="text-muted d-block">GST Number</strong>
                                                                <h6 style={{ background: "rgba(255,255,255,0.6)" }}>{SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && SelectedUsers.Organization[0].GSTNumber}</h6>
                                                                <strong className="text-muted d-block">Contact Number</strong>
                                                                <h6 style={{ background: "rgba(255,255,255,0.6)" }}>{SelectedUsers && SelectedUsers.PhoneNumber}</h6>

                                                            </li>
                                                        </ul>
                                                        <div className='text-center'>
                                                            <span className='cursorpointer' style={{ fontSize: "18px", background: "white", color: "#005582" }}
                                                                onClick={() => onWebSiteClick("www.moversfederation.org")}>www.moversfederation.org</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div style={{ height: "70vh", display: "flex", flexDirection: "column", width: "300px", backgroundPosition: "bottom", borderRadius: "15px", backgroundSize: "cover", backgroundImage: ('url(' + IDCardTheme + ')') }}>
                                                    {SelectedUsers.ExpiryDate && (<div className="validTill">
                                                        <span className="validTillText">Valid Till : {moment(SelectedUsers.ExpiryDate).local().format("MMM YYYY")}</span>
                                                    </div>)}
                                                    <div style={{ backgroundColor: "#005582", width: "100%", marginTop: "5px", height: "40px" }}>
                                                        <div style={{ marginLeft: "10px", display: "flex" }}>
                                                            {ProfilePhoto !== null && (<img style={{
                                                                borderRadius: "50%", border: "5px solid white", position: "relative",
                                                                bottom: "-10px"
                                                            }} alt="User"
                                                                width="130px" height="130px" src={ProfilePhoto}></img>)}
                                                            {(SelectedUsers.Organization && SelectedUsers.Organization.length > 0) && (<span style={{ color: "white", paddingTop: "4px", fontSize: "20px" }}> MFI {SelectedUsers.Organization[0].City}</span>)}
                                                        </div>
                                                    </div>
                                                    <div style={{ textAlign: "right", margin: "15px", flex: "1" }}>
                                                        <QRCode renderAs="svg" bgColor={'white'} size={80}
                                                            includeMargin={false} level="M"
                                                            value={SelectedUsers._id.toString()} />
                                                    </div>
                                                    <div style={{ fontSize: "14px", flex: "2" }}>
                                                        <div style={{ marginTop: "5px" }}>
                                                            <div className="IDCardStyle" title="Membership Number" style={{
                                                                backgroundColor: "white", margin: "0 10px", cursor: "pointer"
                                                            }} onClick={() => onWebSiteClick(((SelectedUsers.Organization && SelectedUsers.Organization.length > 0) ? SelectedUsers.Organization[0].Website : ""))}>{SelectedUsers._id}</div>
                                                        </div>
                                                        <div style={{ marginTop: "5px" }}>
                                                            <table className="table" style={{
                                                                textAlign: "center", borderCollapse: "separate",
                                                                borderSpacing: "0 6px"
                                                            }}>
                                                                <tbody style={{ color: "white", textTransform: "uppercase" }}>
                                                                    <tr>
                                                                        <td style={{ width: "30%", borderRadius: "0 25px 25px 0", backgroundColor: "#005582" }}>Company</td>
                                                                        <td style={{ width: "1%" }}></td>
                                                                        <td style={{ borderRadius: "25px 0 0 25px", backgroundColor: "#005582" }}>
                                                                            <div title={SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && SelectedUsers.Organization[0].Name}
                                                                                style={{ width: "155px", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
                                                                                {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && SelectedUsers.Organization[0].Name}
                                                                            </div></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ width: "30%", borderRadius: "0 25px 25px 0", backgroundColor: "#005582" }}>NAME</td>
                                                                        <td style={{ width: "1%" }}></td>
                                                                        <td style={{ borderRadius: "25px 0 0 25px", backgroundColor: "#005582" }}>
                                                                            <div> {SelectedUsers.FirstName + " " + SelectedUsers.LastName}</div></td>
                                                                    </tr>
                                                                    {SelectedUsers.Organization.length > 0 && (<tr>
                                                                        <td style={{ width: "30%", borderRadius: "0 25px 25px 0", backgroundColor: "#005582" }}>GSt</td>
                                                                        <td style={{ width: "1%" }}></td>
                                                                        <td style={{ borderRadius: "25px 0 0 25px", backgroundColor: "#005582" }}>
                                                                            <div>{SelectedUsers.Organization[0].GSTNumber}</div></td>
                                                                    </tr>)}
                                                                    <tr>
                                                                        <td style={{ width: "30%", borderRadius: "0 25px 25px 0", backgroundColor: "#005582" }}>CONTACT</td>
                                                                        <td style={{ width: "1%" }}></td>
                                                                        <td style={{ borderRadius: "25px 0 0 25px", backgroundColor: "#005582" }}>
                                                                            <div>{SelectedUsers.PhoneNumber}</div></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div className="IDCardWebSiteName">
                                                        <span onClick={() => onWebSiteClick("www.moversfederation.org")}>www.quoinbook.in</span>
                                                    </div>
                                                </div> */}
                                            </div>
                                            <div>
                                                <span title="Business Card Details" className={`${CurrentTheme}Color`}
                                                    style={{ cursor: "pointer", fontSize: "25px", height: "50px" }}
                                                    onClick={onBusinessDetailsClick}>
                                                    <FontAwesomeIcon icon={faAddressCard} /></span>
                                            </div>
                                            {IsBusinessSelected && (<BusinessDetails themeColor={CurrentTheme}
                                                hidebusinessDetails={hidebusinessDetails} SaveBusinessDetails={SaveBusinessDetails} allAbout={SelectedUsers}></BusinessDetails>)}
                                        </div>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-lg-4">
                        <div className="mb-4 pt-3 card card-small" style={{ width: "85%", backgroundPosition: "center", backgroundImage: ('url(' + IDCardTheme + ')') }}>
                            <div className="border-bottom text-center">
                                <div className="mb-2 mx-auto">
                                    {ProfilePhoto !== null && (<img className="rounded-circle" src={ProfilePhoto} alt="Sierra Brooks" width="110"></img>)}
                                </div>
                                <h3 style={{ color: "#005582" }} className="mb-2"><div>
                                    {SelectedUsers.FirstName + " " + SelectedUsers.LastName}
                                </div>
                                </h3>
                            </div>
                            <ul className="list-group list-group-flush">
                                <li className="px-4 list-group-item">
                                    <div className="progress-wrapper d-flex">
                                        <div className='text-center' style={{ textTransform: 'uppercase', margin: "auto" }}>
                                            <strong className="text-muted d-block mb-2">User ID</strong>
                                            <strong className='cursorpointer' onClick={() => onWebSiteClick(((SelectedUsers.Organization && SelectedUsers.Organization.length > 0) ? SelectedUsers.Organization[0].Website : ""))}>
                                                {SelectedUsers._id}</strong>
                                        </div>
                                        {SelectedUsers && SelectedUsers._id && SelectedUsers._id !== "" &&
                                            (<div style={{ textAlign: "right", margin: "5px", flex: "1" }}>
                                                <QRCode renderAs="svg" bgColor={'white'} size={60}
                                                    includeMargin={false} level="M"
                                                    value={SelectedUsers._id.toString()} />
                                            </div>)}
                                    </div>
                                </li>
                                <li className="p-3 list-group-item">
                                    <strong className="text-muted d-block mb-2">Member Name</strong>
                                    <h5 style={{ background: "#F4F4FF", borderRadius: "10px", padding: "5px 5px 5px 10px" }}>{SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && `MFI ${SelectedUsers.Organization[0].City}`}</h5>
                                    <strong className="text-muted d-block mb-2">Organization</strong>
                                    <h5 style={{ background: "#F4F4FF", borderRadius: "10px", padding: "5px 5px 5px 10px", width: "100%", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
                                        {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && SelectedUsers.Organization[0].Name}</h5>
                                    <strong className="text-muted d-block mb-2">GST Number</strong>
                                    <h5 style={{ background: "#F4F4FF", borderRadius: "10px", padding: "5px 5px 5px 10px" }}>{SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && SelectedUsers.Organization[0].GSTNumber}</h5>
                                    <strong className="text-muted d-block mb-2">Contact Number</strong>
                                    <h5 style={{ background: "#F4F4FF", borderRadius: "10px", padding: "5px 5px 5px 10px" }}>{SelectedUsers && SelectedUsers.PhoneNumber}</h5>

                                </li>
                            </ul>
                            <div className='p-1 text-center'>
                                <h5 className='cursorpointer' style={{ background: "white", color: "#005582" }} onClick={() => onWebSiteClick("www.moversfederation.org")}>www.quoinbook.in</h5>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </div >
    );
};

export default MerchantCode;